// @flow
export { default } from './PostCard';



// WEBPACK FOOTER //
// ./src/components/common/PostCard/index.js